export enum PALETTE {
  WHITE = "#FFFFFF",
  GRAY_300 = "#dee2e6",
  GRAY_500 = "#adb5bd",
  RED_700 = "#f03e3e",
  BLUE_500 = "#339af0",
  BLUE_800 = "#1971c2",
  BLACK_700 = "#303030",
  BLACK_900 = "#000000",
}
